import {
    EcommerceEvent,
    EcommerceEventList,
    ReservedTicketList,
} from "../models/Event";
import ClientHeader from "./ClientHeader";
import { Alert, Box } from "@mui/material";
import AuthentigateFooter from "./AuthentigateFooter";
import GlobalLoading from "./GlobalLoading";
import { Toaster } from "react-hot-toast";
import ConfirmDialog from "./ConfirmDialog";
import Script from "next/script";
import { observer } from "mobx-react-lite";
import UICartStore from "../stores/UICartStore";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useCartStore } from "../stores/CartStore";
import { gtm } from "../utils/gtm";
import { useRouter } from "next/router";

const PageWrapper = observer(
    (props: {
        eventList: EcommerceEventList | EcommerceEvent | ReservedTicketList;
        children: React.ReactNode;
        noCart?: boolean;
        baseUrl?: string;
        background?: string;
        overrideLogo?: string;
    }) => {
        const theme = useTheme();
        const cartStore = useCartStore();

        const router = useRouter();
        const { promoCode, salesTrackingKey } = router.query;

        React.useEffect(() => {
            if (promoCode) {
                cartStore?.applyPromoCode(promoCode.toString());
            }
            if (salesTrackingKey) {
                cartStore?.setSalesTrackingKey(salesTrackingKey.toString());
            }
        }, [promoCode, salesTrackingKey]);

        React.useEffect(() => {
            if (props.noCart) {
                UICartStore.setOpen(false);
            }
        }, [props.noCart]);

        React.useEffect(() => {
            if (cartStore?.hasItems && !UICartStore.hasEverBeenOpened) {
                UICartStore.setOpen(true);
            }
        }, [cartStore?.hasItems]);

        React.useEffect(() => {
            if (props.eventList.gtmContainerId) {
                gtm.initializeClient({
                    containerId: props.eventList.gtmContainerId,
                });
            }
        }, []);

        const backgroundUrl =
            props.background || props.eventList.newStyleMap?.backgroundImage;
        const isTiledBackground = backgroundUrl?.includes("bg_tile") || false;

        return (
            <>
                {props.eventList.clientId !== 70 && (
                    <Script
                        async
                        id="ze-snippet"
                        src="https://static.zdassets.com/ekr/snippet.js?key=c4edb3bf-6a0e-4ec6-8625-7d8728a5d40f"
                    ></Script>
                )}
                <main>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            minHeight: "100vh",
                            marginRight: {
                                xs: "0px",
                                lg:
                                    UICartStore.open && !props.noCart
                                        ? "500px"
                                        : "0px",
                            },
                            transition: theme.transitions.create("margin", {
                                easing: theme.transitions.easing.easeInOut,
                                duration:
                                    theme.transitions.duration.enteringScreen,
                            }),
                            backgroundImage: backgroundUrl
                                ? `url(${backgroundUrl})`
                                : "none",
                            backgroundPosition: "bottom",
                            backgroundSize: isTiledBackground
                                ? "500px 500px"
                                : "cover",
                            backgroundRepeat: isTiledBackground
                                ? "repeat"
                                : "no-repeat",
                            backgroundAttachment: "fixed",
                        }}
                    >
                        <Box>
                            {/* {props.eventList.clientId === 66 && (
                                <Alert
                                    severity="error"
                                    sx={{ fontWeight: "bold" }}
                                >
                                    We are currently experiencing issues with
                                    our payment processor. Please try again
                                    later.
                                </Alert>
                            )} */}
                            <ClientHeader
                                eventList={props.eventList}
                                baseUrl={props.baseUrl}
                                overrideLogo={props.overrideLogo}
                            />
                            {props.children}
                        </Box>
                        <AuthentigateFooter
                            cartUrl={props.eventList.cartUrl ?? "authentigate"}
                        />
                    </Box>
                    <Toaster position="top-center" />
                    <ConfirmDialog />
                    <GlobalLoading />
                </main>
                <script>
                    {`
                    window.zESettings = {
                        webWidget: {
                          zIndex: 1
                        }
                      };
                `}
                </script>
            </>
        );
    },
);

export default PageWrapper;
